import { Link } from 'react-router';
import SEO from '../components/SEO';
import { useAuth } from '../contexts/AuthContext';
import { appUrl, isAppHost, isLocalhost } from '../lib/domains';

export default function NotFound() {
  const { user } = useAuth();
  const onAppHost = isAppHost() || isLocalhost();
  const canonical = typeof window !== 'undefined' ? window.location.href.split('?')[0] : undefined;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#fafafa] px-6 text-center">
      {canonical ? (
        <SEO
          title="Page Not Found | LexGat"
          description="The page you requested could not be found on LexGat."
          canonical={canonical}
          robots="noindex, nofollow"
        />
      ) : null}
      <p className="text-sm font-semibold uppercase tracking-wide text-slate-400 mb-3">404</p>
      <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3">Page not found</h1>
      <p className="text-slate-500 max-w-md mb-8">
        The page you are looking for does not exist or may have been moved.
      </p>
      <div className="flex flex-col sm:flex-row items-center gap-3">
        {user && onAppHost ? (
          <Link
            to="/dashboard"
            className="inline-flex items-center justify-center rounded-full bg-zinc-900 px-6 py-3 text-sm font-medium text-white hover:bg-zinc-800 transition-colors"
          >
            Go to dashboard
          </Link>
        ) : (
          <a
            href={onAppHost ? appUrl('/login') : '/'}
            className="inline-flex items-center justify-center rounded-full bg-zinc-900 px-6 py-3 text-sm font-medium text-white hover:bg-zinc-800 transition-colors"
          >
            {onAppHost ? 'Sign in' : 'Back to home'}
          </a>
        )}
        {!onAppHost && user ? (
          <a
            href={appUrl('/dashboard')}
            className="inline-flex items-center justify-center rounded-full border border-zinc-200 bg-white px-6 py-3 text-sm font-medium text-zinc-900 hover:bg-zinc-50 transition-colors"
          >
            Open app
          </a>
        ) : null}
      </div>
    </div>
  );
}
